import React, { useEffect, useState } from 'react';
import { getUserPreference, fetchAvailableSports, setSportPreference } from './Preference';

const Preference = () => {
  const [sports, setSports] = useState([]);
  const [selectedSportId, setSelectedSportId] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const loadData = async () => {
      try {
        const [availableSports, userPreference] = await Promise.all([
          fetchAvailableSports(),
          getUserPreference()
        ]);

        let sortedSports = availableSports;

        if (userPreference?.sport_id) {
          setSelectedSportId(userPreference.sport_id);
          // Move preferred sport to top
          sortedSports = [
            availableSports.find(s => s.id === userPreference.sport_id),
            ...availableSports.filter(s => s.id !== userPreference.sport_id)
          ];
        }

        setSports(sortedSports);
      } catch (error) {
        console.error('Error loading sports or preference:', error);
      }
    };

    loadData();
  }, []);

  const handleChange = async (e) => {
    const sportId = parseInt(e.target.value, 10);
    setSelectedSportId(sportId);

    try {
      setLoading(true);
      await setSportPreference({ sport_id: sportId });
      setLoading(false);
      console.log('Preference updated successfully');
    } catch (error) {
      setLoading(false);
      console.error('Failed to update preference:', error.message);
    }
  };

  return (
    <div className="col-md-6 mb-3 mb-md-0">
      <label className="form-label">Sport</label>
      <select
        className="form-select"
        value={selectedSportId || ''}
        onChange={handleChange}
        disabled={loading}
      >
        <option value="" disabled>Select a sport</option>
        {sports.map(sport => (
          <option key={sport.id} value={sport.id}>
            {sport.display_name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Preference;
